import React from 'react';
import classNames from 'classnames';
import { DayTimeSlot, SlotTime } from 'types';
import dayjs from 'dayjs';

type Props = {
	selectedDaySlot?: DayTimeSlot;
	selectedTimeSlot?: SlotTime;
	setSelectedTimeSlot: (value: any) => void;
	heading?: string;
};

export const EligibilityTimeSelection = ({
	selectedDaySlot,
	selectedTimeSlot,
	setSelectedTimeSlot,
	heading,
}: Props) => {
	return (
		<div className="flex flex-col py-2 md:max-w-[574px]">
			<p className="text-[#544D4F] font-[700] text-[16px] leading-[20px] mb-[20px]">{heading}</p>
			<div className="scrollPracticeTopics max-w-full overflow-x-auto p-2 pl-0">
				<div className="flex flex-wrap gap-4">
					{' '}
					{selectedDaySlot?.slotTimes.map((slotTime: any, index: number) => {
						const isSelected = selectedTimeSlot?.time === slotTime.time;
						return (
							<div key={index}>
								<button
									disabled={dayjs().isAfter(dayjs(slotTime.time).tz('Asia/Kolkata'))}
									className={classNames(
										'disabled:opacity-50 flex-shrink-0 text-center rounded-[8px] flex flex-col gap-[6px] cursor-pointer transition-all duration-200 px-[12px] py-[8px] text-[14px] leading-[20px] font-[500] text-sm',
										isSelected
											? 'bg-[#7777E7] border border-[#5a85e4] text-white'
											: 'bg-[#F7F7FF] border border-[#C7C9D9] text-[#21191B]',
									)}
									onClick={() => setSelectedTimeSlot(slotTime)}
								>
									{dayjs(slotTime.time).format('hh:mm a').toUpperCase()}
								</button>
								{/* <p className="text-[9px] font-[500] leading-[20px] font-inter h-[20px] text-center text-[#848081]">
									Slot is full
								</p> */}
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};
